module.exports = __webpack_public_path__ + "static/media/mongo_mongoose.89491554.svg";